import { FC } from 'react';

interface Props {
	variation?: 'white' | 'green';
	size?: string | number;
	className?: string;
}

const ArrowNext: FC<Props> = ({ variation, size = 24, className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		className={className}
	>
		<path
			d="M8.45199 6.58023L9.51299 5.52024L15.292 11.2972C15.3851 11.3898 15.4591 11.4999 15.5095 11.6211C15.56 11.7424 15.5859 11.8724 15.5859 12.0037C15.5859 12.1351 15.56 12.2651 15.5095 12.3863C15.4591 12.5076 15.3851 12.6177 15.292 12.7102L9.51299 18.4902L8.45299 17.4302L13.877 12.0052L8.45199 6.58023Z"
			fill={variation === 'white' ? '#fff' : variation === 'green' ? '#39F500' : 'currentColor'}
		/>
	</svg>
);

export default ArrowNext;
